import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { ProjetInfo } from "@/types/project";
import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

async function login(token: string) {
  try {
    const url = `${config.isometricApiUrl}/users/login`;
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify({ token }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Login API failed with status ${response.status}`);
    }
    const data = await response.json();
    return data.user;
  } catch (e) {
    throw e;
  }
}

export default function useSaveUserLogin(
  onSettled?: (res: ProjetInfo | undefined, error: Error | null) => void
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: () => {
      try {
        const headers = getAuthHeaders();
        const token = headers.Authorization.replace("Bearer ", "");
        return login(token);
      } catch (error) {
        throw new Error("Authentication required: " + (error as Error).message);
      }
    },
    onSettled,
  });
}
